import Vue from 'vue';

export class FlowRouting {
  constructor(ctx) {
    this.ctx = ctx;

    const { app, $api, softRedirect } = this.ctx;

    this.app = app;
    this.api = $api;
    this.softRedirect = softRedirect;
    this.routes = {};
    this.interval = null;
  }

  define(routes) {
    this.routes = routes;
  }

  initInterval() {
    if (this.interval) return;
    this.interval = setInterval(async () => {
      if (this.app.$auth.loggedIn) await this.fetchStatus();
      if (
        ['registration', 'application', 'profile-my-loan'].some(
          name => this.routeName.indexOf(name) === 0
        )
      ) {
        this.redirect();
      }
    }, 10 * 1000);
  }

  async start() {
    await this.fetchStatus();
    if (this.actual.status === 'active') this.redirect();
  }

  redirect() {
    if (this.setRoute && this.setRoute !== this.routeName && this.actual.status === 'active') {
      this.softRedirect(this.app.localePath(this.setRoute));
    }
  }

  async fetchStatus() {
    const { data, success } = await this.api.dispatch('client/getRoute');
    if (success && data) {
      this.actual = {
        step: data.step,
        status: data.status,
      };
      if (this.actual.status === 'completed') {
        this.softRedirect(this.app.localePath('application-loading'));
      }
    }
  }

  get setRoute() {
    const entry = this.routes[this.actual.step];
    if (Array.isArray(entry)) {
      if (entry.includes(this.routeName)) return this.routeName;
      return entry[0];
    } else {
      return entry;
    }
  }

  get routeName() {
    const [routeName] = this.ctx.route.name.split('___');
    return routeName;
  }

  get actual() {
    return this.ctx.store.state.flowRouting.actual;
  }

  set actual(value) {
    this.ctx.store.commit('flowRouting/set', value);
  }
}

export default (ctx, inject) => {
  const flowRouting = new FlowRouting(ctx);
  ctx.store.registerModule(
    'flowRouting',
    {
      namespaced: true,
      state: () => ({ actual: {} }),
      mutations: {
        set(state, value) {
          Vue.set(state, 'actual', value);
        },
      },
    },
    { preserveState: process.browser }
  );

  inject('flowRouting', flowRouting);

  if (process.browser) {
    setTimeout(() => {
      if (Object.keys(flowRouting.routes).length) flowRouting.initInterval();
    }, 1 * 1000);
  }
};
